import { render, staticRenderFns } from "./EducationPosts.vue?vue&type=template&id=7d6d9722&scoped=true"
import script from "./EducationPosts.vue?vue&type=script&lang=js"
export * from "./EducationPosts.vue?vue&type=script&lang=js"
import style0 from "./EducationPosts.vue?vue&type=style&index=0&id=7d6d9722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6d9722",
  null
  
)

export default component.exports